<template>
  <button
    class="flex flex-row justify-center items-center bg-gray-100 border-2 border-gray-600 text-gray-600 rounded-xl pl-2 pr-1"
    @click="$emit('click')"
  >
    <span class="uppercase"><slot /></span>
    <span class="close">x</span>
  </button>
</template>
<script>
export default {
  name: "DeleteButton"
};
</script>
<style lang="postcss" scoped>
button {
  min-height: 32px;
}
.close {
  @apply bg-black text-white ml-2 w-6 h-6 flex justify-center items-center font-bold;
  font-weight: 500;
  font-size: 18px;
  border-radius: 0.55rem;
}
</style>
